import _classCallCheck from "/drone/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/drone/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/drone/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/drone/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/drone/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Auth, { isCAS } from "../../state/utils/Auth";
import Link from "../common/Link";
import T from "../common/Translate";
import Layout from "./Layout";
import Container from "./Container";
import { BtnLink } from "../styles/buttons";
import { PrimaryLink } from "../styles/links";
import { fullHeight, colors, fonts } from "../styles/variables";
import { RoutesPaths } from "../../shared/constants/RoutesPaths";
var Wrapper = styled.section.withConfig({
  displayName: "Error__Wrapper",
  componentId: "sc-1ipbkld-0"
})(["padding:6% 0;max-width:800px;margin:0 auto;text-align:center;white-space:pre-wrap;", " p{color:", ";}"], fullHeight, colors.gray60);
var Actions = styled.div.withConfig({
  displayName: "Error__Actions",
  componentId: "sc-1ipbkld-1"
})(["text-align:center;display:flex;align-items:center;justify-content:center;flex-direction:column;"]);
var LoginText = styled.div.withConfig({
  displayName: "Error__LoginText",
  componentId: "sc-1ipbkld-2"
})(["", ";"], fonts.R14);
var Error = /*#__PURE__*/function (_Component) {
  _inherits(Error, _Component);
  var _super = _createSuper(Error);
  function Error() {
    _classCallCheck(this, Error);
    return _super.apply(this, arguments);
  }
  _createClass(Error, [{
    key: "getTranslationByEntity",
    value: function getTranslationByEntity(type) {
      var _this$props$entity = this.props.entity,
        entity = _this$props$entity === void 0 ? 'default' : _this$props$entity;
      var isLogged = Auth.isLogged();
      var translationKeys = {
        title: {
          default: 'error.not_found.title',
          spark: 'error.not_found.title_spark',
          track: 'error.not_found.title_track',
          user: 'error.not_found.title_user'
        },
        description: {
          default: 'error.not_found.description',
          spark: isLogged ? 'error.not_found.description_spark_auth' : 'error.not_found.description_spark',
          track: isLogged ? 'error.not_found.description_track_auth' : 'error.not_found.description_track',
          user: isLogged ? 'error.not_found.description_user_auth' : 'error.not_found.description_user'
        }
      };
      var translationType = translationKeys[type];
      var translationByEntity = translationType && (translationType[entity] || translationType['default']);
      return /*#__PURE__*/React.createElement(T, null, translationByEntity);
    }
  }, {
    key: "getActionBtn",
    value: function getActionBtn() {
      var redirect = typeof window !== 'undefined' ? encodeURIComponent(window.location.pathname) : null;
      var actionsTitle = /*#__PURE__*/React.createElement("div", {
        key: "title"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, null, "error.try_again")), /*#__PURE__*/React.createElement("br", null));
      var loginBtn = /*#__PURE__*/React.createElement(LoginText, {
        key: "login"
      }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(T, null, "signup.have_an_acc"), "\xA0", /*#__PURE__*/React.createElement(Link, {
        route: isCAS ? RoutesPaths.AUTH_LOGIN : RoutesPaths.LOGIN,
        params: {
          redirect: redirect
        },
        passHref: true
      }, /*#__PURE__*/React.createElement(PrimaryLink, {
        href: ""
      }, /*#__PURE__*/React.createElement(T, null, "signup.login"))));
      return [actionsTitle, loginBtn];
    }
  }, {
    key: "getActionBtnAuth",
    value: function getActionBtnAuth() {
      return /*#__PURE__*/React.createElement(Link, {
        route: RoutesPaths.TRENDING,
        passHref: true
      }, /*#__PURE__*/React.createElement(BtnLink, {
        size: "large"
      }, /*#__PURE__*/React.createElement(T, null, "error.exit")));
    }
  }, {
    key: "render",
    value: function render() {
      var title = this.getTranslationByEntity('title');
      var description = this.getTranslationByEntity('description');
      var actionBtn = Auth.isLogged() ? this.getActionBtnAuth() : this.getActionBtn();
      return /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("h1", null, title), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, null, "error.not_found.possible_reason")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", null, description), /*#__PURE__*/React.createElement(Actions, null, actionBtn))));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        entity: PropTypes.string
      };
    }
  }]);
  return Error;
}(Component);
export { Error as default };